module.exports = __webpack_public_path__ + "media/images/icon-our-work-cd84a2984bbaa9119981c18e665e78e3.svg";